"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _shared = require("./shared");
var _A11yInfoProvider = require("../A11yInfoProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CY_PROPS = {
  attributeName: 'cy',
  calcMode: 'spline',
  dur: `${_shared.DOTS_TOTAL_ANIMATION_DURATION}ms`,
  repeatCount: 'indefinite'
};
const FILL_PROPS = {
  attributeName: 'fill',
  calcMode: 'linear',
  dur: `${_shared.DOTS_TOTAL_ANIMATION_DURATION}ms`,
  repeatCount: 'indefinite'
};
const OPACITY_PROPS = {
  attributeName: 'opacity',
  calcMode: 'linear',
  dur: `${_shared.DOTS_TOTAL_ANIMATION_DURATION}ms`,
  repeatCount: 'indefinite'
};
const Dots = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    size,
    color,
    indicatorBackgroundColor,
    label,
    isStatic = false
  } = _ref;
  const {
    reduceMotionEnabled
  } = (0, _A11yInfoProvider.useA11yInfo)();
  const reduceMotion = reduceMotionEnabled || isStatic;
  const spacingX = size + _shared.DOTS_SPACING_X;
  const baseY = size * _shared.DOTS_BASE_Y_FACTOR;
  const jumpHeight = size * _shared.DOTS_JUMP_HEIGHT_FACTOR;
  const padding = size * _shared.DOTS_PADDING_FACTOR;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ref: ref,
    "aria-valuetext": label,
    role: "progressbar",
    "aria-busy": "true",
    width: size * 3 + spacingX * 2 + padding * 2,
    height: size * 6,
    viewBox: `0 0 ${size * 3 + spacingX * 2 + padding * 2} ${size * 6}`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: padding + size / 2,
        cy: baseY,
        r: size / 2,
        fill: color,
        children: !reduceMotion && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
            ...CY_PROPS,
            keyTimes: _shared.DOT1_ANIMATION_KEYTIMES,
            keySplines: `${_shared.BOUNCY_CURVE};${_shared.BOUNCY_CURVE};${_shared.BOUNCY_CURVE}`,
            values: `
                  ${baseY};
                  ${baseY - jumpHeight * _shared.OVERSHOOT_FACTOR};
                  ${baseY + jumpHeight * _shared.UNDERSHOOT_FACTOR};
                  ${baseY}
                `
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
            ...FILL_PROPS,
            keyTimes: _shared.DOT1_COLOR_KEYTIMES,
            values: `
                  ${color}; 
                  ${color}; 
                  ${indicatorBackgroundColor}; 
                  ${indicatorBackgroundColor}
                `
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
            ...OPACITY_PROPS,
            keyTimes: _shared.DOTS_FADEOUT_KEYTIMES,
            values: _shared.DOTS_FADEOUT_VALUES
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: padding + size + spacingX + size / 2,
        cy: baseY,
        r: size / 2,
        fill: indicatorBackgroundColor,
        children: reduceMotion ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
            ...CY_PROPS,
            keyTimes: _shared.DOT2_ANIMATION_KEYTIMES,
            keySplines: `
                  ${_shared.BOUNCY_CURVE};
                  ${_shared.BOUNCY_CURVE};
                  ${_shared.BOUNCY_CURVE};
                  ${_shared.BOUNCY_CURVE}
                `,
            values: `
                  ${baseY};
                  ${baseY};
                  ${baseY - jumpHeight * _shared.OVERSHOOT_FACTOR};
                  ${baseY + jumpHeight * _shared.UNDERSHOOT_FACTOR};
                  ${baseY}
                `
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
            ...FILL_PROPS,
            keyTimes: _shared.DOT2_COLOR_KEYTIMES,
            values: `
                  ${indicatorBackgroundColor}; 
                  ${indicatorBackgroundColor}; 
                  ${color}; 
                  ${color}; 
                  ${indicatorBackgroundColor}; 
                  ${indicatorBackgroundColor}
                `
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
            ...OPACITY_PROPS,
            keyTimes: _shared.DOTS_FADEOUT_KEYTIMES,
            values: _shared.DOTS_FADEOUT_VALUES
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: padding + (size + spacingX) * 2 + size / 2,
        cy: baseY,
        r: size / 2,
        fill: indicatorBackgroundColor,
        children: reduceMotion ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
            ...CY_PROPS,
            keyTimes: _shared.DOT3_ANIMATION_KEYTIMES,
            keySplines: `
                  ${_shared.BOUNCY_CURVE};
                  ${_shared.BOUNCY_CURVE};
                  ${_shared.BOUNCY_CURVE};
                  ${_shared.BOUNCY_CURVE}
                `,
            values: `
                  ${baseY};
                  ${baseY};
                  ${baseY - jumpHeight * _shared.OVERSHOOT_FACTOR};
                  ${baseY + jumpHeight * _shared.UNDERSHOOT_FACTOR};
                  ${baseY}
                `
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
            ...FILL_PROPS,
            keyTimes: _shared.DOT3_COLOR_KEYTIMES,
            values: `
                  ${indicatorBackgroundColor}; 
                  ${indicatorBackgroundColor}; 
                  ${color}; 
                  ${color}; 
                  ${color}
                `
          })]
        })
      })]
    })
  });
});
Dots.displayName = 'Dots';
Dots.propTypes = _shared.propTypes;
var _default = exports.default = Dots;